import { User } from 'module/api/user/types';
import { fullName } from 'module/helpers/full-name';

export const getUserLabel = (
  user: Pick<User, 'firstName' | 'lastName' | 'emailId'>,
): string => {
  return fullName(user) || user?.emailId;
};
